exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proC-chart-wrap {\n  padding-top: 30px;\n}\n.proC-chart-wrap .empty-tips {\n  padding: 20px;\n  font-size: 16px;\n  text-align: center;\n}\n", ""]);

// exports
